import { FORMIK_EMPTY_VALUE } from '../../../../constants/validation'

export const LOGIN_FORM_EMAIL_FIELD_NAME_USERNAME = 'username'

export const LOGIN_FORM_EMAIL_FIELD_NAME_PASSWORD = 'password'

export const LOGIN_FORM_EMAIL_INITIAL_VALUES = {
  [LOGIN_FORM_EMAIL_FIELD_NAME_PASSWORD]: FORMIK_EMPTY_VALUE,
  [LOGIN_FORM_EMAIL_FIELD_NAME_USERNAME]: FORMIK_EMPTY_VALUE,
}

export const LOGIN_FORM_EMAIL_SERVER_ERROR_UNABLE_CREDENTIALS =
  'Unable_to_log_in_with_provided_credentials'

export const LOGIN_FORM_EMAIL_SERVER_ERROR_BLOCKED_USER =
  'A_user_with_the_blocked_status_cannot_login'

export const LOGIN_FORM_EMAIL_SERVER_ERROR_IMPORTED_USER =
  'A_user_with_the_imported_status_cannot_login'

export const LOGIN_FORM_EMAIL_SERVER_ERROR_INVITED_USER =
  'A_user_with_the_invited_status_cannot_login'

export const LOGIN_FORM_EMAIL_SERVER_NON_FIELD_ERRORS = {
  [LOGIN_FORM_EMAIL_SERVER_ERROR_BLOCKED_USER]:
    'Error.AUserWithTheBlockedStatusCannotLoginKey',
  [LOGIN_FORM_EMAIL_SERVER_ERROR_IMPORTED_USER]:
    'Error.AUserWithTheImportedStatusCannotLoginKey',
  [LOGIN_FORM_EMAIL_SERVER_ERROR_INVITED_USER]:
    'Error.AUserWithTheInvitedStatusCannotLoginKey',
  [LOGIN_FORM_EMAIL_SERVER_ERROR_UNABLE_CREDENTIALS]:
    'Error.UnableToLogInWithProvidedCredentialsKey',
}

export const LOGIN_FORM_EMAIL_MAX_LENGTH_USERNAME = 255

export const LOGIN_FORM_EMAIL_MAX_LENGTH_PASSWORD = 128
